import MultiParentClothesRail from '../MultiParentClothesRail';

export default class ClothesRail extends MultiParentClothesRail {
  // Keep for now, we'll probably need it when connecting to wall
}
